<template>
    <ModalApp :name="id_modal_cep" style="overflow-y: auto;">
        <div style="padding-top:0; min-height: 250px;" class="modal-body">
            <c-heading-2 style="margin-bottom: 5px;">Encontre seu CEP</c-heading-2>
            <c-span>Digite o máximo de informações para melhorar sua busca.</c-span>
            <form autocomplete="off">
                <div class="row mt-2" style="font-size:16px;">
                    <div class="col-12 col-md-6">
                        <c-form-group class="form-group">
                            <label><strong>Estado</strong></label>
                            <select
                                class="form-control"
                                v-model="filters.uf"
                                style="height: auto; padding: 5px 10px;"
                            >
                                <option v-for="uf in ufs" :value="uf" :key="uf">{{uf}}</option>
                            </select>
                        </c-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <c-form-group class="form-group">
                            <label><strong>Cidade</strong></label>
                            <input
                                autocomplete="nope"
                                id="city-cep"
                                type="text"
                                class="form-control"
                                style="height: auto; padding: 5px 10px;"
                                placeholder="Cidade"
                                v-model="filters.city"
                                @keypress.enter="searchData()"
                            />
                        </c-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <c-form-group class="form-group">
                            <label><strong>Bairro</strong></label>
                            <input
                                autocomplete="nope"
                                type="text"
                                class="form-control"
                                style="height: auto; padding: 5px 10px;"
                                placeholder="Bairro"
                                v-model="filters.district"
                                id="bairro-cep"
                                @keypress.enter="searchData()"
                            />
                        </c-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <c-form-group class="form-group">
                            <label><strong>Rua</strong></label>
                            <input
                                autocomplete="nope"
                                type="text"
                                class="form-control"
                                style="height: auto; padding: 5px 10px;"
                                placeholder="Rua"
                                v-model="filters.street"
                                id="rua-cep"
                                @keypress.enter="searchData()"
                            />
                        </c-form-group>
                    </div>
                </div>
            </form>
            <hr :style="`margin: 0 0 10px 0; border-color: ${border_color_site}`">
            <div class="row">
                <div class="col-12">
                    <c-button 
                        :backgroundColor="$root.$children[0].theme.products.button.background_color"
                        :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                        :color="$root.$children[0].theme.products.button.color"
                        :colorHover="$root.$children[0].theme.products.button.color_hover"
                        :borderColor="$root.$children[0].theme.products.button.border_color"
                        :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                        :borderRadius="$root.$children[0].theme.products.button.border_radius"
                        margin="0px 0rem 0px 5px"
                        textTransform="uppercase"
                        height="3.8rem"
                        minWidth="unset"
                        padding="1rem 2rem"
                        display="flex"
                        textAlign="center"
                        lineHeight="1.5"
                        letterSpacing="unset"
                        transition="all .3s"
                        justifyContent="center"
                        @click="searchData()"
                    >
                        <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">Pesquisar</span>
                        <span class="icon-search ml-1"></span>
                    </c-button>
                </div>
                <div class="col-12 mt-1" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
                    <div class="table-responsive">
                        <c-table class="table table-hover table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th style="min-width:8rem;" scope="col">Cep</th>
                                    <th style="min-width:9rem;" scope="col">Cidade</th>
                                    <th style="min-width:6rem;" scope="col">Estado</th>
                                    <th style="min-width:6rem;" scope="col">Bairro</th>
                                    <th scope="col">Rua</th>
                                    <th scope="col">Complemento</th>
                                </tr>
                            </thead>
                            <tbody>
                                <LoadingApp
                                    :isLoading.sync="isLoading" 
                                    :is_full_page="true"
                                /> 
                                <tr
                                    v-for="(item, key) in data" :key="key" 
                                    @click="uncheck(key)"
                                    style="cursor: pointer;"
                                >
                                    <td><input v-model="item.checked" type="checkbox"/></td>
                                    <td>{{item.postal_code}}</td>
                                    <td>{{item.city}}</td>
                                    <td>{{item.uf}}</td>
                                    <td>{{item.district}}</td>
                                    <td>{{item.street}}</td>
                                    <td>{{item.complement}}</td>
                                </tr>
                            </tbody>
                        </c-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer float-right" style="height: auto; padding: 1.5rem 3rem;">
            <c-button
                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                margin="0px 0rem 0px 5px"
                textTransform="uppercase"
                height="3.8rem"
                minWidth="unset"
                padding="1rem 2rem"
                display="flex"
                textAlign="center"
                lineHeight="1.5"
                letterSpacing="unset"
                transition="all .3s"
                justifyContent="center"
                @click="setCep()"
                class="btn btn-primary"
            >
                <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">OK</span>
            </c-button>
        </div>
    </ModalApp>    
</template>

<script>
import ModalApp from './ModalApp.vue'
import infiniteScroll from 'vue-infinite-scroll'
import { mapActions } from 'vuex'
import { CButton } from './Styles/Button/styled'
import LoadingApp from './LoadingApp.vue'
import { CFormGroup, CHeading2, CSpan, CTable } from './Styles/Components/styled'

export default {
    name: 'SearchPostalCode',
    directives: {
        infiniteScroll
    },
    components: {
        ModalApp,
        'c-button': CButton,
        LoadingApp,
        'c-heading-2': CHeading2,
        'c-span': CSpan,
        'c-form-group': CFormGroup,
        'c-table': CTable
    },
    data() {
        return {
            border_color_site: this.$root.$children[0].theme?.border_color_site ?? '#dfdfdf',
            id_modal_cep: 'modal_cep',
            busy: false,
            data: [],
            count: 0,
            current_page: 0,
            last_page: 1,
            isLoading: false,
            filters: {
                city: null,
                street: null,
                complement: null,
                district: null,
                uf: null
            },
            ufs: ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"]
        }
    },
    created() {
        this.isLoading = false;
    },
    methods: {
        ...mapActions("shipping", [
            "ActionGetCities"
        ]),
        async loadMore(pagination = true, page = null) {        
            const dados = { payload: this.filters, page: page??(this.current_page + 1) }
            if(pagination) {
                if(dados.page > this.last_page && this.data.length)return
            }  
            if(this.isLoading) return          
            this.isLoading = true
            let result = await this.ActionGetCities(dados)
            result.data.data.map(el => {
                el.checked = false
                this.data.push(el)
            })
            // this.data.push(...result.data.data) 
            this.current_page = result.data.current_page
            this.last_page = result.data.last_page
            this.isLoading = false
        },
        setCep() {
            this.$emit('searchedCep', 
                this.data.find(el => el.checked === true).postal_code
            );
            this.$root.closeModalApp('modal_cep')
        },
        searchData() {
            this.data = []
            this.loadMore(true, 1)
        },
        uncheck(key) {
            this.data.map((el, index) => {
                if(key !== index)return el.checked = false
                return el.checked = true
            })
        }

    }
}
</script>
